export const settingsInitialState: any = {
  isAdmin: false,
};

export const clientSettingsInitialState: any = {
  version: 2,
  showCampaignColumns: [
    'actions',
    'type',
    'name',
    'warnings',
    'user',
    'potential',
    // 'to_be_outreached',
    'outreached',
    'invites_to_connections_rate',
    'connections_to_responses_rate',
    'total_positive_responses',
    'total_links_clicked',
    'creation_date',
    'in_sequence',
  ],
  showConnectionsColumns: [
    'first_name',
    'last_name',
    'headline',
    'email',
    'phone',
    'user',
    'tags',
    'response',
    'conversation',
    'positions',
    'companies',
    'imported_date',
  ],
  showPeopleColumns: [
    'linkedin_url', 'lead_data_status', 'first_name', 'last_name', 'headline', 'email', 'phone', 'companies', 'user', 'tags', 'connections', 'positions', 'location', 'campaigns', 'status',
  ],
  isNavCollapsed: false,
  openMenuItems: ['inbox'],
  campaignFilters: {
    campaigns: [],
    users: [],
    campaign_types: [],
    date: 'lifetime',
    date_range_start: '',
    date_range_end: '',
    actions: [],
  },
  prospectsFilter: {
    date: 'last_30_days',
    start: 0,
    order: 'sent_date',
    order_direction: '-',
  },
  connectionsFilter: {
    date: 'last_30_days',
    start: 0,
  },
  showNewClientRunCampaignsTip: true,
  showMobileWarning: true,
};
